var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 464,
    height: 312,
    viewBox: "0 0 464 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Feature-4-svg-a",
    x: 240,
    y: 0,
    width: 224,
    height: 312,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Feature-4-svg-c",
    x: 0,
    y: 0,
    width: 224,
    height: 312,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(240)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -252, -10)",
    filter: "url(#Feature-4-svg-a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 288,
    rx: 8,
    transform: "translate(252 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 104) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 168) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 152,
    rx: 6.5,
    transform: "translate(176 200) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 137) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 92,
    rx: 6,
    transform: "translate(116 232) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(35 18)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18.971,
    y: 17
  }, "Employment"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.523,
    y: 35
  }, "Contract"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -10)",
    filter: "url(#Feature-4-svg-c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 288,
    rx: 8,
    transform: "translate(12 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 34,
    transform: "translate(121 224)",
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 104) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 168) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 152,
    rx: 6.5,
    transform: "translate(176 200) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 137) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 92,
    rx: 6,
    transform: "translate(116 232) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(35 18)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18.971,
    y: 17
  }, "Employment"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.523,
    y: 35
  }, "Contract")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(369 224)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.667 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.746,40A3.746,3.746,0,0,1,17.3,39.71,26.94,26.94,0,0,1,5.518,29.363,35.408,35.408,0,0,1,0,10,3.73,3.73,0,0,1,2.313,6.537l15-6.25a3.765,3.765,0,0,1,2.883,0l15,6.25A3.734,3.734,0,0,1,37.5,10a37.23,37.23,0,0,1-1.764,11.544,32.438,32.438,0,0,1-4.382,8.749A27.8,27.8,0,0,1,20.187,39.71,3.738,3.738,0,0,1,18.746,40ZM13.273,17.289a1.587,1.587,0,0,0-1.606,1.563V25.1a1.587,1.587,0,0,0,1.606,1.563H25.06A1.587,1.587,0,0,0,26.667,25.1V18.852a1.587,1.587,0,0,0-1.607-1.563h-.8V14.946a5.092,5.092,0,0,0-10.179,0v2.343Zm5.894,6.771a1.323,1.323,0,0,1-1.34-1.3V21.2a1.34,1.34,0,0,1,2.679,0v1.563A1.323,1.323,0,0,1,19.167,24.06Zm2.41-6.771H16.756V14.946a2.411,2.411,0,0,1,4.821,0v2.343Z",
    transform: "translate(0 0)",
    fill: "#04be9d"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0,.5l157,101",
    transform: "translate(200 156.5)",
    fill: "none",
    stroke: "#4135af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.48
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4);
export default __webpack_public_path__ + "static/media/feature4.0f5e67ef671cdbbf5e4856a97d89fd66.svg";
export { ForwardRef as ReactComponent };